import { useEffect, useRef } from 'react';

// Toggles `pressedClassName` on pointerdown/up, mirroring the reference's
// `[data-press]` behavior — a quick scale-down that eases back via the
// --spring curve defined on the element's own `.spring`-equivalent class.
export function usePressSpring(pressedClassName) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !pressedClassName) return;

    const down = () => el.classList.add(pressedClassName);
    const up = () => el.classList.remove(pressedClassName);

    el.addEventListener('pointerdown', down);
    el.addEventListener('pointerup', up);
    el.addEventListener('pointerleave', up);
    el.addEventListener('pointercancel', up);
    return () => {
      el.removeEventListener('pointerdown', down);
      el.removeEventListener('pointerup', up);
      el.removeEventListener('pointerleave', up);
      el.removeEventListener('pointercancel', up);
    };
  }, [pressedClassName]);

  return ref;
}
